import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import StepperFormInt from "../src/Components/DigitalResume/StepperForm/StepperForm";
import "./App.css";
import ForgotPassword from "./Components/Auth/ForgotPassword/ForgotPassword";
import Login from "./Components/Auth/Login/Login";
import OtpScreen from "./Components/Auth/OtpScreen/OtpScreen";
import Avatar from "./Components/Avatar/Avatar";
import AvatarSelectionForm from "./Components/Avatar/AvatarSelectionForm";
import CreateUser from "./Components/Createuser/Createuser";
import DealerShipDashBoard from "./Components/DealerShipDashBoard/DealerShipDashBoard";
import AddDealershipForm from "./Components/DealershipForm/AddDealershipForm";
import Header from "./Components/Header/Header";
import AddProduct from "./Components/Products/AddProduct";
import ProfileCard from "./Components/ProfileCard/ProfileCard";
import SideBar from "./Components/SideBar/SideBar";
import SubscriptionPlans from "./Components/SubscriptionPlans/SubscriptionPlans";
import UsersTable from "./Components/UsersTable/UsersTable";
import DynamicForm from "./Components/DynamicForm/DynamicForm";
import StepperForm from "./Components/StepperForm/StepperForm";
import Home from "./Components/Home/Home";
import NewLandingPage from "./Components/Home/newLandingpage";
import AdminDashboard from "./Components/AdminDashboard/AdminDashboard";
import DealsTable from "./Components/DealerShipDashBoard/DealsTable";
import ResumeAvatar from "./Components/DigitalResume/PitchAimee/Avatar";
import AvatarBoard from "./Components/f&i_Product/Avatar";
import TestBoard from "./Components/f&i_Product/TestBoard";
import Cars from "./Components/Car";
import CustomerManagement from "./Components/Customer";
import Deals from "./Components/Deals";
import DemoDataPage from "./Components/Demo/DemoDataPage";
import InDealership from "./Components/Int-DealershipForm/AddDealershipForm";
import { ThemeProvider } from "./Components/BrandColors/Context/ThemeContext";

const ProtectedRoute = ({ children, isAuthenticated }) => {
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />;
};

const RedirectIfAuthenticated = ({ children, isAuthenticated }) => {
  return isAuthenticated ? <Navigate to="/" replace /> : <>{children}</>;
};

const App = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  console.log("isAuntenticate = > ", isAuthenticated);

  const [isOpen, setIsOpen] = useState(false);
  const sidebarRef = useRef(null);
  const user = JSON.parse(localStorage.getItem("user"));

  return (
    <ThemeProvider>
      <ToastContainer position="top-right" autoClose={2000} />
      <Router>
        <div className={`App ${isOpen ? "shifted" : ""}`}>
          <Routes>
          <Route path="/dy" element={<DynamicForm />} />
            <Route
              path="/login"
              element={
                <RedirectIfAuthenticated isAuthenticated={isAuthenticated}>
                  <Login />
                </RedirectIfAuthenticated>
              }
            />
            <Route
              path="/forgotPassword"
              element={
                <RedirectIfAuthenticated isAuthenticated={isAuthenticated}>
                  <ForgotPassword />
                </RedirectIfAuthenticated>
              }
            />
            <Route
              path="/reset-password"
              element={
                <RedirectIfAuthenticated isAuthenticated={isAuthenticated}>
                  <ForgotPassword />
                </RedirectIfAuthenticated>
              }
            />
            <Route
              path="/otp"
              element={
                <RedirectIfAuthenticated isAuthenticated={isAuthenticated}>
                  <OtpScreen />
                </RedirectIfAuthenticated>
              }
            />
            <Route
              path="/dy"
              element={
                <RedirectIfAuthenticated isAuthenticated={isAuthenticated}>
                  <DynamicForm />
                </RedirectIfAuthenticated>
              }
            />

            <Route
              path="/"
              element={
                isAuthenticated ? (
                  <ProtectedRoute isAuthenticated={isAuthenticated}>
                    <div className="main-layout">
                      <SideBar
                        isOpen={isOpen}
                        setIsOpen={setIsOpen}
                        sidebarRef={sidebarRef}
                      />
                      <div
                        className={
                          isOpen ? "protected-content" : "protected-content isClose"
                        }
                      >
                        <Header />
                        {user?.role === "Owner" ? (
                          <AdminDashboard />
                        ) : (
                          <DealerShipDashBoard />
                        )}
                      </div>
                    </div>
                  </ProtectedRoute>
                ) : (
                  <NewLandingPage />
                )
              }
            />

            <Route
              path="/f&i-service"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <StepperForm />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/createuser"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <CreateUser />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/deals"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <Deals />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/cars"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <Cars />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/customer"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <CustomerManagement />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/user-management"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <UsersTable />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/avatar-selection"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <AvatarSelectionForm />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/avatar-playground"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <Avatar />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/subscriptions"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <SubscriptionPlans />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/dealership"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <AddDealershipForm />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/pitch-dealership"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <InDealership />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/pitch-aimee"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <StepperFormInt />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/testboard"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <TestBoard />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/products"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <AddProduct />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <ProfileCard />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <DealerShipDashBoard />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/demo"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <DemoDataPage />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/step"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <StepperForm />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />
            <Route
              path="/deals-table"
              element={
                <ProtectedRoute isAuthenticated={isAuthenticated}>
                  <div className="main-layout">
                    <SideBar
                      isOpen={isOpen}
                      setIsOpen={setIsOpen}
                      sidebarRef={sidebarRef}
                    />
                    <div
                      className={
                        isOpen ? "protected-content" : "protected-content isClose"
                      }
                    >
                      <Header />
                      <DealsTable />
                    </div>
                  </div>
                </ProtectedRoute>
              }
            />

            {/* Non-Protected Routes */}
            <Route path="/board" element={<AvatarBoard />} />
            <Route path="/pitch-aimee-board" element={<ResumeAvatar />} />
            <Route path="/newlanding" element={<NewLandingPage />} />
            <Route path="/new-landing" element={<NewLandingPage />} />
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
};

export default App;